import { isNull } from 'lodash';
import * as PnpApprovalWorkflowActions from '../pnp-approval-workflow.actions'
import * as PnpSettingsActions from '../../pnp-settings.actions'
import { IDS } from '../pnp-approval-workflow.constants';

/**
 * @const {object}
 * @memberOf module:policies
 */
export const pnpSettingsApprovalWorkflowDetails = {
    /* @ngInject */
    controller: function ($ngRedux, $state, $scope, $rootScope, FileActions, Notifier) {
        const unsubscribe = $ngRedux.connect(({ policies }) => ({
            pnpSettingsApprovalWorkflow: policies.pnpSettingsApprovalWorkflow
        }), {
            ...FileActions,
            ...PnpApprovalWorkflowActions,
            ...PnpSettingsActions
        })(this);

        /**
         * @function $onInit
         */
        this.$onInit = () => {

            const operation = this.pnpSettingsApprovalWorkflow.id ? 'Update' : 'Add';
            this.title = `${operation} Approval Workflow`;

            this.stateIdentifier = IDS.pnpSettingsApprovalWorkflow;

            if (this.pnpSettingsApprovalWorkflow.id) {
                this.identifier = IDS.app_policies_settings_approval_workflows_manage;
                this.state = IDS.app_policies_settings_approval_workflows_manage_details;
            }
            else {
                this.identifier = IDS.app_policies_settings_approval_workflows_add;
                this.state = IDS.app_policies_settings_approval_workflows_add_details;
            }

            this.getSettingsApprovalWorkflowCategories();
            this.getSettingsApprovalWorkflowRiskLevels();
            this.getSettingsApprovalWorkflowContainerTypes();
        }

        this.saveDetails = () => {
            $scope.$broadcast('show-errors-check-validity', '$ctrl.pnpSettingsApprovalWorkflowForm');
            if (this.pnpSettingsApprovalWorkflowForm.$valid) {
 
                if (this.pnpSettingsApprovalWorkflow.selectedApprovers.length === 0) {
                    Notifier.error('Please add atleast one approver');
                    return;
                }

                this.saveSettingsApprovalWorkflow(this.pnpSettingsApprovalWorkflow).then(() => {
                    this.pnpSettingsApprovalWorkflow.id
                        ? Notifier.success('Approval workflow has been successfully updated.')
                        : Notifier.success('Approval workflow has been successfully created.');
                    isNull(this.pnpSettingsApprovalWorkflow.id) && this.resetForm();
                }).catch(() => {
                    Notifier.error('This approval workflow already exists');
                });
            } else {
                Notifier.error('Please fill in the form fields');
            }
        }

        this.resetForm = () => {
            this.pnpSettingsApprovalWorkflowForm.$setPristine();
            this.pnpSettingsApprovalWorkflowForm.$setUntouched();
        };

        this.onAddReviewerButton = () => {

            if (this.pnpSettingsApprovalWorkflow.selectedReviewers.some(item => item.value === this.pnpSettingsApprovalWorkflow.selectedReviewer.value)) {
                Notifier.error('COMMON.CLIENT_RESPONSE.ITEM_PRESENT_ALREADY');
                return;
            }

            if (this.pnpSettingsApprovalWorkflow.selectedReviewer) {
                if (this.pnpSettingsApprovalWorkflowForm.reviewerCandidateAutocomplete) {  
                    this.pnpSettingsApprovalWorkflowForm.reviewerCandidateAutocomplete.$setViewValue('');
                    this.pnpSettingsApprovalWorkflowForm.reviewerCandidateAutocomplete.$render();
                }
                this.addReviewerContacts({
                    value: this.pnpSettingsApprovalWorkflow.selectedReviewer.value,
                    label: this.pnpSettingsApprovalWorkflow.selectedReviewer.label
                });
            }
        }

        this.onRemoveReviewer = (item) => {
            this.removeReviewerContacts(item)
        }

        this.onAddApproverButton = () => {

            if (this.pnpSettingsApprovalWorkflow.selectedApprovers.some(item => item.value === this.pnpSettingsApprovalWorkflow.selectedApprover.value)) {
                Notifier.error('COMMON.CLIENT_RESPONSE.ITEM_PRESENT_ALREADY');
                return;
            }

            if (this.pnpSettingsApprovalWorkflow.selectedApprover) {
                if (this.pnpSettingsApprovalWorkflowForm.approverCandidateAutocomplete) {  
                    this.pnpSettingsApprovalWorkflowForm.approverCandidateAutocomplete.$setViewValue('');
                    this.pnpSettingsApprovalWorkflowForm.approverCandidateAutocomplete.$render();
                }
                this.addApporverContacts({
                    value: this.pnpSettingsApprovalWorkflow.selectedApprover.value,
                    label: this.pnpSettingsApprovalWorkflow.selectedApprover.label
                });
            }
        }

        this.onRemoveApprover = (item) => {
            this.removeApproverContacts(item)
        }


        /**
         * @function $onDestroy
         */
        this.$onDestroy = () => {
            unsubscribe();
        }
    },
    template: require('./pnp-approval-workflow-details.html')
}
